import { Toaster } from "sonner";
import { Nav } from "./Nav";
import { Footer } from "./Footer";
import { CookieBanner } from "./CookieBanner";

export const SiteLayout = ({ children }) => {
  return (
    <div className="min-h-screen bg-cream flex flex-col" data-testid="site-layout">
      <Nav />
      <main className="flex-1 pt-20 md:pt-24">{children}</main>
      <Footer />
      <CookieBanner />
      <Toaster
        position="bottom-right"
        toastOptions={{
          style: {
            background: "#F8F7F3",
            border: "1px solid #E9EDF0",
            color: "#14283F",
            fontFamily: "Manrope, sans-serif",
          },
        }}
      />
    </div>
  );
};
